<script>
  import { format } from "date-fns";
  import it from "date-fns/locale/it";

  export let date;
  export let locale;

  $: currentLocale = locale === "it" ? it : null;
  $: displayMonth = (date) =>
    format(new Date(date), "MMM", { locale: currentLocale });

  const displayDay = (date) => format(new Date(date), "dd");
  const displayYear = (date) => format(new Date(date), "yyyy");
</script>

<div class="calendar">
  <div>
    <p class="mm">{displayMonth(date)}</p>
    <p class="day">{displayDay(date)}</p>
    <p class="yy">{displayYear(date)}</p>
  </div>
</div>

<style>
  .calendar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 80px;
    height: 80px;
    text-align: center;
    flex: 0 0 auto;
  }

  .mm {
    text-transform: uppercase;
    font-weight: 700;
  }

  .yy {
    font-weight: 300;
    font-size: 14px;
  }

  .day {
    font-weight: 700;
    font-size: 24px;
  }

  p {
    margin: 0;
  }
</style>
